/* @flow */
import * as React from "react";
import idx from "idx";
import { connect } from "react-redux";
import styled from "styled-components";
import Gettext from "../common/Gettext";
import withData from "../withData";
import _Money from "../Money";
import { tournamentCurrency } from "../Icons/Kuchka";

import type { MapStateToProps } from "react-redux";
import type { State as ReduxState } from "../../redux/reducer";
import type { Account, Profile, Stock } from "../../redux/CommonTypes";

const Container = styled.div`
  padding-top: 15px;
  padding-bottom: 14px;
  text-align: center;
  border-top: 1px dashed ${({ theme }) => theme.borderMainColor};
  border-bottom: 1px dashed ${({ theme }) => theme.borderMainColor};
`;

const AnimatedContainer = styled(Container)`
  animation: 1.3s ${({ glow }) => `glow-${glow}`} cubic-bezier(0.4, 0, 1, 1);

  @keyframes glow-positive {
    0% {
      text-shadow: 0 0 5px ${({ theme }) => theme.accent},
        0 0 10px ${({ theme }) => theme.accent},
        0 0 25px ${({ theme }) => theme.upper},
        0 0 30px ${({ theme }) => theme.upper};
    }
    40% {
      text-shadow: 0 0 5px ${({ theme }) => theme.accent},
        0 0 10px ${({ theme }) => theme.accent},
        0 0 15px ${({ theme }) => theme.upper},
        0 0 20px ${({ theme }) => theme.upper};
    }
    100% {
      text-shadow: none;
    }
  }

  @keyframes glow-negative {
    0% {
      text-shadow: 0 0 5px ${({ theme }) => theme.accent},
        0 0 10px ${({ theme }) => theme.accent},
        0 0 25px ${({ theme }) => theme.lower},
        0 0 30px ${({ theme }) => theme.lower};
    }
    40% {
      text-shadow: 0 0 5px ${({ theme }) => theme.accent},
        0 0 10px ${({ theme }) => theme.accent},
        0 0 15px ${({ theme }) => theme.lower},
        0 0 20px ${({ theme }) => theme.lower};
    }
    100% {
      text-shadow: none;
    }
  }
`;

const Heading = styled.div`
  display: block;
  margin-bottom: 7px;
  font-size: ${({theme}) => theme.locale === "ar" ? theme.minFontSize : "14px"};
  line-height: 1;
  text-align: center;
  color: #99959d;
`;

const Money = styled(_Money)`
  display: block;
  font-weight: 700;
  font-size: 22px;
  line-height: 1;
  text-align: center;
  color: ${props => props.theme.accent};
`;

type Props = {
  mode: "tournament" | "binary",
  bid: number,
  percent: number,
  accounts: Array<Account>,
  profile: Profile,
  accountType: string,
  stock: Stock
};

type State = {
  percentUpdateIndication: false | "positive" | "negative"
};

class Profit extends React.Component<Props, State> {
  state = {
    percentUpdateIndication: false
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    const percentageChanged =
      this.props.percent !== null && nextProps.percent !== this.props.percent;
    const stockChanged = this.props.stock !== nextProps.stock;
    const accountChanged = this.props.accountType !== nextProps.accountType;

    if (percentageChanged && !stockChanged && !accountChanged) {
      const indication =
        nextProps.percent > this.props.percent ? "positive" : "negative";

      this.setState({ percentUpdateIndication: indication }, () => {
        this.timer = setTimeout(
          () => this.setState({ percentUpdateIndication: false }),
          1000
        );
      });
    }
  }

  componentWillUnmount() {
    clearTimeout(this.timer);
  }

  render() {
    const { bid, stock, mode } = this.props;
    const currency = mode === "tournament" ? tournamentCurrency : null;

    let C =
      this.state.percentUpdateIndication === false
        ? Container
        : AnimatedContainer;

    const activeAccount = this.props.accounts.find(
      account => account.id === this.props.profile.active_account_id
    );

    let percent = 0;

    if (activeAccount) {
      percent =
        activeAccount.type === "real" ? stock.realProfit : stock.demoProfit;

      if (mode === "tournament") {
        percent = stock.realProfit - stock.profit_vip;
      }
    }

    return (
      <C glow={this.state.percentUpdateIndication}>
        <Heading>
          <Gettext>PROFIT</Gettext> {percent}%
        </Heading>
        <Money currency={currency}>{bid + (bid * percent) / 100}</Money>
      </C>
    );
  }
}

const mapStateToProps = (state: ReduxState) => {
  const tabs = idx(state, state => state.tabs.tabs);
  const active = idx(state, state => state.tabs.activeTab);
  const stocks = idx(state, state => state.stocks);

  if (tabs != null && active != null && stocks != null) {
    return {
      mode: state.settings.mode,
      stock: stocks[tabs[active]]
    };
  }

  return {
    mode: state.settings.mode
  };
};

export default withData(["accounts", "profile"])(
  connect((mapStateToProps: MapStateToProps<*, *, *>))(Profit)
);



// WEBPACK FOOTER //
// ./src/components/TradeControls/Profit.js